import React from 'react';

import { Container, Row, Col } from 'react-bootstrap';

import { db } from "./firebase";
import { collection, Firestore, getDocs, setDoc, updateDoc, arrayUnion, getDoc } from "firebase/firestore";
import { queryDict } from "./queryString";
import MainTask from "./components/MainTask";
import Instructions from './components/Instructions';
import Title from './components/Title';
import TaskComplete from './components/TaskComplete';
import BlockUser from './components/BlockUser';
import RepeatedTask from './components/RepeatedTask';

function generateRandomHexString(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

class App extends React.Component {
    instructionsOpen = false;
    answers = {};

    constructor(props) {
        super(props);
        this.state = {
            userData: {
                blackList: false,
                numberOfHits: 0,
            },
            workerId: 'empty',
            assignmentId: 'empty',
            hitId: 'empty',
            blockUser: false,
            informativeness: 0,
            startTime: new Date().getTime() / 1000 / 60,
            completedTask: false,
            repeatedTaskForUser: false,
            compensationHit: (queryDict.compensationMode === "true"),
            compensationWorkerId: "",
            compensationUnavailable: "false",
            nQuestions: 0,
            correctModification: "false",
            randomHash: generateRandomHexString(16)
        };
        if ('PROLIFIC_PID' in queryDict) {
            this.state.workerId = queryDict.PROLIFIC_PID
        } else {
            this.state.workerId = queryDict.workerId
        }
        if ('SESSION_ID' in queryDict) {
            this.state.assignmentId = queryDict.SESSION_ID
        }
        if ('hash' in queryDict) {
            this.state.hitId = `${queryDict.modification_type}-${queryDict.hash}`
        }

        console.log("[constructor]: worker id =", this.state.workerId)
        this.saveRealTimeResult = this.saveRealTimeResult.bind(this)
        console.log("[constructor]:", this.state)
    }

    async componentDidMount() {
        // test: read data from fireStore [success]
        // console.log("show some data: ")
        // const docref = db.collection('test').doc('doc1')
        // docref.get().then(function (doc) {
        //         if (doc && doc.exists) {
        //             console.log(doc.data())
        //         } else {
        //             console.log("nothing.")
        //         }
        //     }
        // )

        // test: write data to fireStore [success]
        // const docRef = db.collection('test').doc('doc1');
        // docRef.set({
        //     value: "write test",
        // })

        console.log("[componentDidMount] starts")
        console.log(this)

        // initialize database connection and write an empty array to save user results
        const resRef = db.collection('realtime-results').doc(`${queryDict.modification_type}-${queryDict.hash}`).collection('results').doc(`${this.state.randomHash}`);
        this.resRef = resRef;
        setDoc(this.resRef, {answers: []}, {merge: true})
        // this.resRef.set({
        //     answers: []
        // });

        // If the current user has already worked on this HIT (identified by user id), block the user from working on it (show a special page)
        
        // for in-house annotation
        // check whether this user has submitted result for this (this.state.hitId) hash already
        if (this.state.workerId !== 'empty') {
            console.log("[componentDidMount] hitId:", this.state.hitId)
            const docRef = db.collection("results").doc(`${this.state.hitId}`).collection("workerId").doc(`${this.state.workerId}`)

            docRef.get().then((doc) => {
                console.log("[componentDidMount] check repeated task")
                var data = {};
                var repeatedTask = false;
                if (doc && doc.exists) {
                    data = doc.data();
                    console.log(`${this.state.workerId}`, "repeated question for user")
                    repeatedTask = true;
                } else {
                    console.log(`new question for user: ${this.state.workerId}`)
                    repeatedTask = false
                }
                return [data, repeatedTask]
            })
            .then((res) => {
                var data = res[0];
                var repeatedTask = res[1];
                this.setState({ repeatedTaskForUser: repeatedTask });
            })
        }
        
    }

    setOpenInstructions = (open) => {
        this.instructionsOpen = open;
    }

    async saveRealTimeResult(answer, explanation, idx) {
        try {
            console.log("[saveRealTimeResult]", {
                'answer': answer,
                'explanation': explanation,
                'time': new Date(),
                'instance_index': idx,
                'worker_id': this.state.workerId
            })
            await updateDoc(this.resRef, {
                answers: arrayUnion({
                    'answer': answer,
                    'explanation': explanation,
                    'time': new Date(),
                    'instance_index': idx,
                    'worker_id': this.state.workerId
                })
            });
            console.log('Array updated with:', answer);
        } catch (error) {
        console.error('Error updating document:', error);
        }
    }

    saveUserInfoToFireStore = (resultData, userData) => {
        console.log("[saveUserInfoToFireStore] starts")
        const docRef = db.collection('users').doc(`${this.state.workerId}`).collection('assignments').doc(`${this.state.assignmentId}`);

        // Update Firestore.
        // docRef.set({
        //     numberOfHits: 0,
        //     blackList: false
        // })
        // calculate the control score
        // const matchCount = this.computeControlScore(resultData);
        
        const currentDateTime = new Date();
        docRef.set({
            blackList: false,
            controlScore: 0, // there are 2 control questions for each HIT
            hitId: this.state.hitId,
            submitTime: currentDateTime
        })
    }

    decrementString = (input) => {
        const decremented = Array.from(input).map(char => {
            if (char >= 'a' && char <= 'z') {
                // Wrap-around for lowercase letters
                return char === 'a' ? 'z' : String.fromCharCode(char.charCodeAt(0) - 1);
            } else if (char >= 'A' && char <= 'Z') {
                // Wrap-around for uppercase letters
                return char === 'A' ? 'Z' : String.fromCharCode(char.charCodeAt(0) - 1);
            } else if (char >= '0' && char <= '9') {
                // Wrap-around for digits
                return char === '0' ? '9' : String.fromCharCode(char.charCodeAt(0) - 1);
            } else {
                // Return other characters unchanged
                return char;
            }
        }).join('');
    
        return decremented;
    }



    saveResultToFireStore = (resultData) => {
        console.log("[saveResultToFireStore] starts")      
       
        const docRef = db.collection('results').doc(`${queryDict.modification_type}-${queryDict.hash}`).collection('workerId').doc(`${this.state.workerId}`);
        const sessionDocRef = db.collection('results').doc(`${queryDict.modification_type}-${queryDict.hash}`).collection('sessions').doc(`${queryDict.SESSION_ID}`)
        
        const userRef = db.collection('users').doc(`${this.state.workerId}`);

        var numberOfHits = this.state.userData['numberOfHits'];
        var timeTaken = (new Date().getTime() / 1000 / 60 - this.state.startTime); // Times are in milliseconds we express them in minutes
        if (typeof numberOfHits === 'undefined' || isNaN(numberOfHits)) {
            numberOfHits = 0;
        }
        var userData = {
            ...this.state.userData,
            numberOfHits: numberOfHits + 1,
            blackList: false  // TODO: modify code here
        };
        docRef.set({
            ...resultData,
            time_taken: timeTaken,
            submit_time: new Date(),
            study_id: queryDict.STUDY_ID || 'empty',
            session_id: queryDict.SESSION_ID || 'empty'
        }).then(() => {
            console.log("[saveUserInfoToFireStore] update firestore")
            return userRef.set(userData);
        }).then(() => {
            resultData['numberOfHits'] = userData['numberOfHits'];
            resultData['blackList'] = userData['blackList'];
        }).catch(function (error) {
            console.log("Got an error saving results to firestore.", error);
        });

        sessionDocRef.set({
            ...resultData,
            time_taken: timeTaken,
            submit_time: new Date(),
            study_id: queryDict.STUDY_ID || 'empty',
            session_id: queryDict.SESSION_ID || 'empty',
            user_id: this.state.workerId
        }).catch((error) => {
            console.log("sessionDocRef updated.")
        })

    }

    submitMainTask = (resultData, userData) => {
        /*
            `resultData` should not contain Set. It should be all JSON.stringifyable.
        */
        // Update firestore.
        // this.setFirestorePostMturkResultData(resultData);
        // this.submitResult(resultData);
        
        console.log("[submitMainTask] starts")
        this.saveUserInfoToFireStore(resultData, userData);
        this.saveResultToFireStore(resultData)
        // Set task complete.
        // this.setState({ completedTask: true });
        // var completionCode = this.decrementString(queryDict.completionCode);
        // console.log("completionCode (URL param):", queryDict.completionCode);
        // console.log("completionCode (after decoding):", completionCode)

        window.location.href = `https://app.prolific.com/submissions/complete?cc=${queryDict.completionCode}`;
    }

    handleChange = (event) => {
        let fieldName = event.target.name;
        let fieldValue = event.target.value;

        if (fieldName.includes('compensation')) { // the "Yes"/"No" radio button
            console.log("[handleChange App.js] worker id:", fieldValue)
            this.setState({
                compensationWorkerId: fieldValue
            });
        }
    }

    render() {
        // Instructions and title.
        if (this.state.completedTask) {
            return (
                <TaskComplete 
                    handleChange
                />
            );
        }

        const Task = () => {
            // if (this.state.blockUser) {
            //     return <BlockUser />;
            // } else if (this.state.repeatedTaskForUser) {
            //     return <RepeatedTask/>
            // } else {
            //     return (
            //         <MainTask
            //             submitMainTask={this.submitMainTask}
            //             saveRealTimeResult={this.saveRealTimeResult}
            //             hash={queryDict.hash}
            //         />
            //     )
            // }
            return (
                        <MainTask
                            submitMainTask={this.submitMainTask}
                            saveRealTimeResult={this.saveRealTimeResult}
                            hash={queryDict.hash}
                        />
                    )
        }

        return (
            <div className="row">
                <div className="col-md-12 mb-4">
                    <Task />
                </div>
            </div>
        );
    }
}

export default App;